import { SvgProps } from './interface/SvgProps';

const SvgMorning = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    viewBox="0 0 65 65"
    {...props}
  >
      <path
        fill="#E7E4D9"
        d="M20 3.333A16.666 16.666 0 0 0 3.333 20h8.334A8.333 8.333 0 0 1 20 11.667V3.333ZM20 36.667A16.666 16.666 0 0 0 36.667 20h-8.334A8.335 8.335 0 0 1 20 28.333v8.334ZM3.333 20A16.667 16.667 0 0 0 20 36.667v-8.334A8.333 8.333 0 0 1 11.666 20H3.333Z"
      />
      <path fill="#0B7D75" d="M36.666 20A16.667 16.667 0 0 0 20 3.333v8.334A8.333 8.333 0 0 1 28.333 20h8.334Z" />
    </svg>
);
  
export default SvgMorning;
